import tabTitle from './tab-title'
export default {
  install (Vue) {
    Vue.use(tabTitle);
  }
}



// WEBPACK FOOTER //
// ./src/directives/index.js